/**
 * @generated SignedSource<<353e22f01b9ff53f1dec67a4838e12f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type FileAccessType = "public" | "signedUrl";
import { FragmentRefs } from "relay-runtime";
export type offerFilesTable_FilesListFragment$data = {
  readonly Admin: {
    readonly Offer: {
      readonly OfferFiles: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly accessType: FileAccessType;
            readonly fileType: string;
            readonly id: string;
            readonly name: string;
            readonly thumbnail: string | null;
            readonly uploadDateTime: string;
            readonly url: string | null;
          };
        } | null> | null;
        readonly pageInfo: {
          readonly endCursor: string | null;
          readonly hasNextPage: boolean;
          readonly hasPreviousPage: boolean;
          readonly startCursor: string | null;
        };
      };
    };
  };
  readonly " $fragmentType": "offerFilesTable_FilesListFragment";
};
export type offerFilesTable_FilesListFragment$key = {
  readonly " $data"?: offerFilesTable_FilesListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"offerFilesTable_FilesListFragment">;
};

import OfferFilesTable_Refetch_graphql from './OfferFilesTable_Refetch.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "Admin",
  "Offer",
  "OfferFiles"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByFileTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByFromDateTimeInclusive"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByToDateTimeInclusive"
    },
    {
      "defaultValue": [
        "IssuedCertificate"
      ],
      "kind": "LocalArgument",
      "name": "filterFileTagsExcluded"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterFileTagsIncluded"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": OfferFilesTable_Refetch_graphql
    }
  },
  "name": "offerFilesTable_FilesListFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OfferAdminSchema",
          "kind": "LinkedField",
          "name": "Offer",
          "plural": false,
          "selections": [
            {
              "alias": "OfferFiles",
              "args": [
                {
                  "kind": "Variable",
                  "name": "fileType",
                  "variableName": "filterByFileTypes"
                },
                {
                  "kind": "Variable",
                  "name": "fromDateTimeInclusive",
                  "variableName": "filterByFromDateTimeInclusive"
                },
                {
                  "kind": "Variable",
                  "name": "name",
                  "variableName": "filterByName"
                },
                {
                  "kind": "Variable",
                  "name": "tagsExcluded",
                  "variableName": "filterFileTagsExcluded"
                },
                {
                  "kind": "Variable",
                  "name": "tagsIncluded",
                  "variableName": "filterFileTagsIncluded"
                },
                {
                  "kind": "Variable",
                  "name": "toDateTimeInclusive",
                  "variableName": "filterByToDateTimeInclusive"
                }
              ],
              "concreteType": "FilesConnection",
              "kind": "LinkedField",
              "name": "__OfferFilesTable_OfferFiles_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasPreviousPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startCursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FilesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "File",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fileType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accessType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "uploadDateTime",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "thumbnail",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "url",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "5bd3a74dd7617360a1d3f0e77ebfdddc";

export default node;
